module.exports = __webpack_public_path__ + "img/red_envelopes1.cff91a7a.png";